import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPoints } from '../../helpers/quests';
import { WeekTimer } from './WeekTimer';

const Metric = ({ label, value }) => (
  <div className="flex-1 flex flex-col space-y-[0.6rem] p-[2rem] dashboard-block-styles lg:p-[1.6rem]">
    <span className="text-[1.3rem] text-white-500">{label}</span>
    <span className="text-[2.4rem] font-600 text-white leading-none lg:text-[2rem]">{value}</span>
  </div>
);

export const QuestsSummary = ({ data }) => {
  const { t } = useTranslation();
  const total = data?.coreTotal ?? data?.quests?.length ?? 0;
  const done = data?.completedCount ?? 0;

  return (
    <div className="flex flex-col space-y-[1.2rem]">
      <div className="flex space-x-[1.2rem] lg:flex-col lg:space-x-0 lg:space-y-[1.2rem]">
        <Metric label={t('quests.balance')} value={`${formatPoints(data?.pointsBalance)} PP`} />
        <Metric label={t('quests.thisWeek')} value={`+${formatPoints(data?.weekPoints)} PP`} />
        <Metric label={t('quests.completed')} value={`${done}/${total}`} />
      </div>
      {data?.week && (
        <div className="flex flex-col space-y-[1rem] p-[2rem] dashboard-block-styles">
          <div className="flex items-center justify-between text-[1.3rem] lg:flex-col lg:items-start lg:space-y-[0.4rem]">
            <span className="text-white">{t('quests.fullClear', { bonus: data.fullClearBonus })}</span>
            <WeekTimer endsAt={data.week.endsAt} className="text-white-500" />
          </div>
          <div className="h-[0.8rem] rounded-[2rem] bg-white-100 overflow-hidden">
            <div
              className="h-full rounded-[2rem] bg-primary custom-transition"
              style={{ width: `${total ? (done / total) * 100 : 0}%` }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
